<template>
  <!--  create folder dialog   -->
  <qc-dialog class="tc-15-rich-dialog cos" :show="show" type="custom" :title="$t(`core.create_${createType}`)"
    :default-cancel="false" :width="420" @close="closeDialog">
    <ul class="form-list">
      <li class="pure-text-row">
        <div class="form-label">
          <label>{{$t(`core.${createType}_name`)}}</label>
        </div>
        <div class="form-input">
          <div class="form-unit" :class="{'is-error':!validateStatus}">
            <input class="tc-15-input-text m" v-focus maxlength="255" v-model.trim="createName" style="width:250px;"
              @keyup="validateName" @input="validateName" @keypress.enter="onCreate()">
            <qc-bubble popupClass="dialog-bubble" class="ml-10" placement="bottomRight">
              <qc-icon type="plaint" style="cursor:pointer"></qc-icon>
              <template slot="popup">
                <span>{{$t(`cos.tips.${createType}_name[0]`)}}</span>
                <span><br>{{$t(`cos.tips.${createType}_name[1]`)}}</span>
                <span><br>{{$t(`cos.tips.${createType}_name[2]`)}}</span>
                <span v-if="createType=='folder'"><br>{{$t(`cos.tips.${createType}_name[3]`)}}</span>
              </template>
            </qc-bubble>
            <p class="form-input-help" v-if="createType=='folder'">{{$t(`cos.validate.${validateCode}`)}}</p>
          </div>
        </div>
      </li>
    </ul>

    <div slot="button">
      <div class="justify-grid">
        <div class="col"></div>
        <div class="col">
          <qc-button type="default" @click="onCreate()" :title="$t('core.ok')"
            :disabled="!validateStatus || !createName">{{$t('core.ok')}}</qc-button>
          <qc-button type="weak" @click="closeDialog" :title="$t('core.close')">{{$t('core.close')}}</qc-button>
        </div>
      </div>
    </div>

  </qc-dialog>
</template>

<script>
import { tips, getStringBytes, getFileEndType } from '@/scripts/tools/utils';
import cos from '@/scripts/helper/cos';
import eventProxy from '@/scripts/tools/eventProxy';
import dialog from '@/scripts/tools/dialog';

export default {
  props: {
    bucketInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: false,
      createType: 'folder',
      createName: '',
      validateStatus: true,
      validateCode: 'folder_name_length',
    };
  },
  mounted() {
    eventProxy.on('create.show', this.initData);
  },
  destroyed() {
    eventProxy.off('create.show', this.initData);
  },
  methods: {
    // 弹窗打开后初始化重命名的文件项
    initData(type) {
      this.createType = type;
      this.show = true;
      this.createName = '';
      this.validateStatus = true;
      this.validateCode = `${type}_name_length`;
    },
    validateName() {
      let errCode = `${this.createType}_name_length`;
      const name = this.createName;
      this.validateStatus = true;
      const isFolder = this.createType === 'folder';

      if (name === '' || /^\s+$/.test(name)) {
        this.validateStatus = false;
        errCode = `${this.createType}_name[0]`;
      }

      if (isFolder && name.length > 255) {
        this.validateStatus = false;
        errCode = `${this.createType}_name[1]`;
      }

      if (name[0] === '/') {
        this.validateStatus = false;
        errCode = `${this.createType}_name[2]`;
      }

      if (name.indexOf('//') !== -1) {
        this.validateStatus = false;
        errCode = `${this.createType}_name[3]`;
      }

      if (isFolder && name.split('/').indexOf('..') !== -1) {
        this.validateStatus = false;
        errCode = `${this.createType}_name[4]`;
      }

      if (isFolder) {
        let folderPath = `${this.bucketInfo.prefix + name}`;
        // 即如果用户自己补了 / 的话，则不添加 /
        if (folderPath.slice(-1) !== '/') {
          folderPath += '/';
        }

        if (getStringBytes(folderPath) > 850) {
          this.validateStatus = false;
          errCode = 'folder_name[5]';
        }
      }

      this.validateCode = errCode;
      return errCode;
    },

    exsitSameName(key, notips) {
      const { Bucket, Region } = this.bucketInfo;
      return new Promise(resolve => {
        // 1. 确认是否存在同名文件
        cos.headObject(
          {
            Bucket,
            Region,
            Key: key,
          },
          err => {
            if (err) {
              if (err.statusCode === 404) {
                // 2. 不存在则直接进行重命名
                resolve(true);
              } else if (err.error === 'Forbidden' && err.statusCode === 403) {
                tips.error(this.$t('error.no_permissions_to_head_object'));
              } else {
                const code = err.error || err.code;
                tips.error(
                  window.lang.err(`error.${code}`, err.code ? err : err.code),
                );
              }
              resolve(false);
              return;
            }
            if (notips) {
              resolve(false);
              return;
            }
            // 3. 存在则提示是否覆盖
            dialog.confirm(
              {
                title: window.lang.t('core.default_title'),
                message: window.lang.t('cos.confirm.rename_cover'),
              },
              confirm => {
                if (confirm) {
                  resolve(true);
                } else {
                  resolve(false);
                }
              },
            );
          },
        );
      });
    },
    async onCreate(notips) {
      const { Bucket, Region, Prefix } = this.bucketInfo;
      const name = notips ? '' : this.createName;
      const isFolder = this.createType === 'folder';
      let key = `${Prefix + name}`;
      const fileType = getFileEndType(key);
      if (isFolder) {
        // 如果用户自己补了 / 的话，则不添加 /
        if (key.slice(-1) !== '/') {
          key += '/';
        }
      }
      if (!this.validateStatus && !notips) {
        return;
      }
      const allowCreate = await this.exsitSameName(key, notips);
      if (!allowCreate) return;

      const params = {
        Bucket,
        Region,
        Key: key,
        Body: '',
        SkipTask: true,
        Headers: {
          'Content-Type': fileType,
        },
      };
      isFolder && (params.ContentType = 'application/x-directory');
      cos.putObject(params, err => {
        if (err) {
          tips.error(
            this.$t('core.fail', { msg: this.$t(`core.create_${this.createType}`) }),
          );
        } else if (!notips) {
          tips.success(
            this.$t('core.success', { msg: this.$t(`core.create_${this.createType}`) }),
          );
          if (isFolder) {
            const item = { Prefix: key };
            this.$emit('push-list', [item]); // 增加文件夹
            this.$emit('finish-create', key, true); // 增加文件夹后直接追加节点
          } else {
            this.$emit('refresh'); // 增加文件则刷新界面
            this.$emit('finish-create', key, false); // 增加文件后直接追加节点
          }
        }
        this.closeDialog();
      });
    },
    closeDialog() {
      this.show = false;
    },
  },
};
</script>

<style>
</style>
